// FIXME: Remove all of these at some point - dangerous to use on frontend since no guarantee these materials exist.
// anything in this list should either be sent down in all VendorData or generated on the client.
export enum MaterialKey {
  BlackMetal = 'black-metal',
  DiamondPlate = 'diamond-plate',
  EntryDoorWindowGridMaterialWhite = 'entry-door-window-grid-material-white',
  FrostedGlass = 'frosted-glass',
  Glass = 'glass',
  LPSmartSideTrim = 'lp-smartside-trim',
  OSB = 'osb',
  PaintedMetalBase = 'painted-metal-base',
  PaintedMetalBaseNoReflections = 'painted-metal-base-no-reflections',
  PaintedWoodBase = 'painted-wood-base',
  PaintedWoodBaseWithGrain = 'painted-wood-base-with-grain',
  PressureTreatedWood = 'pressure-treated-wood',
  RusticShiplapSiding = 'rustic-shiplap-siding',
  StainlessSteel = 'stainless-steel',
  StainlessSteelBrushedElongated = 'stainless-steel-brushed-elongated',
  TransparentGlass = 'transparent-glass',
  VinylBase = 'vinyl-base',
  VinylDoubleDoorPanelingBase = 'vinyl-double-door-paneling-base',
}
